import { Check, X } from "lucide-react";
import { PIPELINE_STAGES } from "@/lib/constants";

export const PipelineStepper = ({ status }) => {
  const isRejected = status === "Rejected";
  const stages = PIPELINE_STAGES.map((s) => (s === "Selected" && isRejected ? "Rejected" : s));
  const currentIdx = stages.indexOf(status);

  return (
    <div data-testid="pipeline-stepper" className="w-full overflow-x-auto pb-1">
      <div className="flex items-start min-w-[420px]">
        {stages.map((stage, i) => {
          const done = i < currentIdx;
          const current = i === currentIdx;
          const terminal = stage === "Rejected";
          return (
            <div key={stage} className="flex-1 flex flex-col items-center relative">
              {i > 0 && (
                <span
                  className={`absolute left-[-50%] right-[50%] top-[13px] h-0.5 ${
                    i <= currentIdx ? (terminal && i === currentIdx ? "bg-red-400" : "bg-emerald-500") : "bg-border"
                  }`}
                />
              )}
              <span
                className={`relative z-10 h-7 w-7 rounded-full flex items-center justify-center border-2 text-[10px] font-semibold ${
                  done
                    ? "bg-emerald-500 border-emerald-500 text-white"
                    : current
                    ? terminal
                      ? "bg-red-500 border-red-500 text-white"
                      : "bg-primary border-primary text-white ring-4 ring-primary/15"
                    : "bg-white border-border text-muted-foreground"
                }`}
              >
                {done ? <Check className="h-3.5 w-3.5" /> : current && terminal ? <X className="h-3.5 w-3.5" /> : i + 1}
              </span>
              <span className={`mt-2 text-[11px] text-center leading-tight px-1 ${current ? "font-semibold text-foreground" : "text-muted-foreground"}`}>
                {stage}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
